import React from "react";

import { ColumnDefinition } from "@nens/chakra/components";

import { TableOverview } from "@/components/table-overview";
import { renderDefault } from "@/helpers/table-render-functions";
import { useAllFetchedPagination } from "@/hooks/use-pagination";
import { KEY_ADDON_MAP } from "@/hooks/use-router-table-data";

export type RegistrationGmnMeasuringPoint = {
  eventType: string;
  measuringPointCode: string;
  gmwBroId: string;
  tubeNumber: number;
  eventDate: string;
};

export const gmnMeasuringPointInformation: {
  key: keyof RegistrationGmnMeasuringPoint;
  label: string;
}[] = [
  { key: "eventType", label: "Bericht type" },
  { key: "measuringPointCode", label: "Meetpuntcode" },
  { key: "gmwBroId", label: "GMW BRO ID" },
  { key: "tubeNumber", label: "Buisnummer" },
  { key: "eventDate", label: "Datum" },
];

const columnDefinitions: ColumnDefinition<RegistrationGmnMeasuringPoint>[] =
  gmnMeasuringPointInformation.map(({ key, label }) => ({
    title: label,
    renderFunction: (row) => {
      return renderDefault(row[key]);
    },
    width: "1fr",
  }));

const GmnMeasuringPointTable: React.FC<{ measuringPoints: RegistrationGmnMeasuringPoint[] }> = ({
  measuringPoints,
}) => {
  const { paginatedTableData, ...paginationProps } = useAllFetchedPagination(
    KEY_ADDON_MAP.GMN_FORM,
    measuringPoints
  );

  // OF paginatedTableData, filterout with eventType === "GMN_StartRegistration"
  const filteredTableData = paginatedTableData.filter(
    (measuringPoint) => measuringPoint.eventType !== "GMN_StartRegistration"
  );

  return (
    <TableOverview
      paginationProps={paginationProps}
      minHeight="300px"
      emptyText="Nog geen meetpunten toegevoegd"
      tableData={filteredTableData.map((measuringPoint) => ({
        ...measuringPoint,
        uuid: measuringPoint.measuringPointCode + measuringPoint.tubeNumber,
      }))}
      columnDefinitions={columnDefinitions}
    />
  );
};

export { GmnMeasuringPointTable };
